export default {
  REACT_APP_VERSION: "1.0.0",
  //Development
  //    PCNA_SERVICE_URL: "http://localhost:7071/api/",
  //Testing
  // PCNA_SERVICE_URL: "http://10.0.116.8/api/",

  // PCNA_SERVICE_URL: "http://52.152.186.77/api/"
  PCNA_SERVICE_URL: "https://pcnalosservices-prod.azurewebsites.net/api/",
//  PCNA_SERVICE_URL: "https://pcnalosservice-stage.azurewebsites.net/api/",
  //PCNA_SERVICE_URL: "http://10.0.115.238:7071/api/",
};
